package twist.mena.sports.shared.dto.common

import kotlinx.serialization.Serializable

@Serializable
data class HealthResponse(
    val status: String,
    val checks: Map<String, String>? = null
)
